import { Typography } from "@mui/material";
import { format, parseISO } from "date-fns";

interface Props {
  readonly effectiveDate?: Date | string | null;
}

export function EffectiveDate({ effectiveDate }: Props) {
  const date =
    typeof effectiveDate === "string" ? parseISO(effectiveDate) : effectiveDate;

  return (
    <>
      <Typography variant="caption" color="text.secondary" fontSize={16}>
        Endorsement Effective Date
      </Typography>
      <Typography variant="body2">
        {date ? format(date, "MMM d, yyyy") : "-"}
      </Typography>
    </>
  );
}
